export default "__VITE_ASSET__wkvChbQ0__"